import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  inject,
} from '@angular/core';
import { SmartEditService } from '../services/smart-edit.service';

@Directive({
  selector: '[boelsSlotDecorator]',
  standalone: true,
})
export class SlotDecoratorDirective implements OnInit {
  private _elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);
  private smartEditService = inject(SmartEditService);

  @Input('boelsSlotDecorator') properties: any;

  ngOnInit() {
    this.smartEditService.addSmartEditContract(
      this._elementRef.nativeElement,
      this.renderer,
      this.properties,
    );
  }
}
